<script>
export default {
  props: {
    verified: {
      type: Boolean,
      default() {
        return false
      },
    },
    verify: {
      type: Boolean,
      default() {
        return false
      },
    },
    session: {
      type: Boolean,
      default() {
        return false
      },
    },
    email: {
      type: Boolean,
      default() {
        return false
      },
    },
    message: {
      type: String,
      default() {
        return ''
      },
    },
  },
}
</script>

<template>
  <div>
    <section ref="verifiationSession" :class="$style.loginSection">
      <b-container fluid>
        <b-container>
          <b-row
            :class="$style.rowAlign"
            class="align-items-center justify-content-center"
          >
            <b-col sm="10" md="7" lg="6" class="FL tc">
              <div
                v-if="verified"
                :class="[$style.verificationWraper, $style.success]"
              >
                <h3 class="mt20">Account Verified</h3>
                <p>Your account is verified<br /><span>Redirecting...</span></p>
              </div>
              <div
                v-else-if="session"
                :class="[$style.verificationWraper, $style.error]"
              >
                <h3 class="mt20">Session Expired</h3>
                <p
                  >{{ message !== '' ? message : 'Your session is expired'
                  }}<br /><span>Redirecting to login...</span></p
                >
              </div>
              <div
                v-else-if="email"
                :class="[$style.verificationWraper, $style.error]"
              >
                <h3 class="mt20">Email send</h3>
                <p>Please check your mail to reset your password</p>
              </div>
              <div
                v-else-if="!verify"
                :class="[$style.verificationWraper, $style.error]"
              >
                <h3 class="mt20">Verification Failed</h3>
                <p>Sorry your verification is failed</p>
              </div>

              <div
                v-if="verify"
                :class="[$style.verificationWraper, $style.success]"
              >
                <h3 class="mt20">Password Set</h3>
                <p
                  >Please login with new Credentials<br /><span
                    >Redirecting...</span
                  ></p
                >
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </section>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.loginSection {
  position: relative;
  z-index: 99;
  width: 100%;
  min-height: 100vh;
  background-color: #f15d22;
  background-size: cover;
}

.rowAlign {
  min-height: 100vh;
}

.verificationWraper {
  position: relative;
  width: 100%;
  padding: 50px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);

  h3 {
    font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
      Apple Color Emoji;
  }

  &.success h3 {
    color: $color-success;
  }

  &.error h3 {
    color: $color-error;
  }

  p {
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    color: $primary-font-color;

    span {
      display: block;
      margin-top: 10px;
      color: $primary-color;
    }
  }
}
</style>
